<template>
  <div class="week-by-car-num">
    <div class="wrapper">
      <div style="font-weight: bold">加能站停靠统计</div>
<!--      <exportDate v-if="showExport" @hideExport="showExport = false" :moduleName="moduleName"/>-->
<!--      :provinCode="provinceCode"-->
      <dimension-dialog v-if="showExport" :params="params" @hideExport="showExport = false" :moduleName="moduleName" :autoChunkMonth="true"/>
      <div class="header">
        <el-form :inline="true">
          <el-form-item label="统计月份">
            <dimension-popover
                ref="objDimensionPopover"
                :isMapValue="true"
                :dimObj="dimObj"
                :change="changeDimension"
                :showBottomButton="false"
                :isItemBindClick="true"
            />
          </el-form-item>
          <el-form-item label="站点类型" label-width="75px">
            <el-select v-model="formData.zhanDianType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="吨位区间" label-width="75px">
            <el-select v-model="formData.dunwei" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in dunWeiOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="燃料类型" label-width="75px">
            <el-select v-model="formData.ranliaoType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in ranliaoOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button style="margin-left:30px;" @click="onDebounceSearch" class="searchBtn">查询</el-button>
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exFun">导出全部明细</el-button>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
<!--        <el-table-column type="index" fixed label="序号" align="center" width="50" fixed="left"/>-->
        <el-table-column prop="provname" label="统计省份" align="center" fixed="left"></el-table-column>
        <el-table-column prop="stopCount" min-width="220" label="全部油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="sinopecStopCount" min-width="220" label="S级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="sinopecStopCountRate" min-width="220" label="S级油站停靠占比" align="center"></el-table-column>

        <el-table-column prop="petrochinaStopCount" min-width="220" label="C级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="petrochinaStopCountRate" min-width="220" label="C级油站停靠占比" align="center"></el-table-column>

        <el-table-column prop="otherStopCount" min-width="220" label="E级油站停靠次数(次)" align="center"></el-table-column>
        <el-table-column prop="otherStopCountRate" min-width="220" label="E级油站停靠占比" align="center"></el-table-column>

        <el-table-column label="" min-width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.provname!='合计'" style="color:#1137FF;cursor: pointer;" @click="getCityDataValXia(scope.row)">下辖地区统计</span>
          </template>
        </el-table-column>
        <el-table-column label="" min-width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.provname!='合计'" style="color:#1137FF;cursor: pointer;" @click="getCityDataVal(scope.row)">来源省份统计</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBlock">
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png"/>
        <span>说明</span>
      </h4>

      <div>1.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
      <div>2.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>3.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>4.停靠次数：统计区域内加能站车辆停靠次数。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
      <div>5.停靠占比：不同站点品牌停靠次数÷全部油站停靠次数。</div>
      <div>6.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>7.下一级页面：点击“下辖地区统计”、“来源省份统计”进入对应页面。</div>

    </div>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import _ from 'lodash'
// import areaList from './components/areaList'
import detailCard from '@/components/detailCard.vue'
import WeekPopover from '../../freight/weekByCarNum/components/weekPopover.vue'
import WeekDialog from '../../freight/weekByCarNum/components/weekDialog.vue'
import Util from '@/utils/util'
import devLog from "components/devLog.vue";
import seeTopFive from "components/seeTopFive.vue";
import {hideExport} from "utils/tools";
import dimensionDialog from "components/exportDate/daphne/dialog.vue";
import dimensionPopover from "components/exportDate/daphne/popover.vue";
import Cookies from "js-cookie";
import {exportProvinceSimplify, progress} from "api/log";
import get from 'lodash/get';
import set from 'lodash/set';
import each from 'lodash/each';

export default {
  name: 'week-by-car-num',
  components: {dimensionDialog, dimensionPopover, seeTopFive, devLog, WeekPopover, WeekDialog, detailCard},
  data() {
    let value4 = Util.lastTime(new Date())
    let arr = value4.split('-')
    let dimObj = {
      year: '',
      month: '',
      type: '0'
    }
    return {
      // moduleName: 'pathwayProvinceOil',
      moduleName: 'oilStationBerthProvinceV2',
      hideExport: hideExport,
      showExport: false, //控制批量导出
      tableHeight1: this.tableHeight,
      nrData: {},
      dimObj, // 纬度对象
      ranliaoOption:Util.ranLiaoOption,
      dunWeiOption: Util.dunWeiOption,
      zhanDianOption:Util.zhanDianOption,
      formData: {
        time: '',
        dunwei:[],
        ranliaoType:[],
        zhanDianType:[],
        zhanDianBrand:[],
      },
      tableCol: [
        {
          name: '运营车辆数',
          children: [
            {name: '全部车辆', prop: 'runCarNum0'},
            {name: '柴油车辆', prop: 'runCarNum1'},
            {name: 'LNG车辆', prop: 'runCarNum2'},
            {name: '新能源车辆', prop: 'runCarNum3'},
          ],
        },
        {
          name: '运营里程',
          children: [
            {name: '全部车辆', prop: 'totalMile0'},
            {name: '柴油车辆', prop: 'totalMile1'},
            {name: 'LNG车辆', prop: 'totalMile2'},
            {name: '新能源车辆', prop: 'totalMile3'},
          ],
        },
      ],

      curDate: '',
      tableData: [],
      onDebounceSearch: _.debounce(this.onSearch, 500),
      total: 0, // 总页数
      index: 1, // 当前页数
      pageSize: 20,
      areaListPr: '',
      params:{}
    }
  },
  mounted() {
    // 初始化formData.time以保持兼容性
    this.formData.time = this.dimObj.year + this.dimObj.month
    this.getData(1)
  },
  methods: {
    changeDimension(e) {
      if (e.isOk) {
        let type = e.type
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = type
        // 更新formData.time以保持兼容性
        this.formData.time = e.year + e.month
      }
    },
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)
      let dateType = get(this, 'dimObj.type', '0')
      window.location.assign(
          exportProvinceSimplify({
            reqId,
            dateType,
            year: this.dimObj.year || "",
            month: this.dimObj.month || "",
            stationTypes:this.formData.zhanDianType,
            tonnages:this.formData.dunwei,
            fuelTypes:this.formData.ranliaoType,
          })
      )
    },
    exFun(){
      this.params={
        year: this.dimObj.year || "",
        month: this.dimObj.month || "",
        stationTypes:this.formData.zhanDianType,
        tonnages:this.formData.dunwei,
        fuelTypes:this.formData.ranliaoType,
      }
      this.showExport = true
    },
    closeProAll(curr) {
      this[curr] = false
    },
    seeDevLog(row) {
      this.devLogIs = true
      this.currRow = row
    },
    seeTopFive(row) {
      this.seeTopFiveIs = true
      this.currRow = row
    },
    changeSearch() {
      if (this.value1) {
        this.tableHeight1 = this.tableHeight - 120
      } else {
        this.tableHeight1 = this.tableHeight
      }
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    getListP(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        resolve(nodes);
      })
    },
    getCityDataVal(row){
      this.$router.push({
        path: 'carStopXiaBrand',
        query: {
          provCode: row.provcode,
          year: row.year,
          month: row.month,
          type:this.dimObj.type
        }
      })
    },
    getCityDataValXia(row){
      this.$router.push({
        path: 'carStopNengBrand',
        query: {
          provCode: row.provcode,
          year: row.year,
          month: row.month,
          type:this.dimObj.type
        }
      })
    },
    toDetail(row) {
      this.isShowMes = true
      this.nrData = row
    },
    changeDetail() {
      this.isShowMes = false
    },
    onChangePage(index) {
      this.index = index
      this.getData(2)
    },
    onSearch() {
      this.index = 1
      this.total = 0
      this.getData(2)
    },
    getData(num = 2) {
      if (num == 2 && (!this.dimObj.year && !this.dimObj.month)) {
        this.$message({
          message: '请选择月份',
          type: 'warning',
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let dateType = get(this, 'dimObj.type', '0')
      const params = {
        dateType,
        pageNum: this.index,
        pageSize: this.pageSize,
        year: this.dimObj.year || "",
        month: this.dimObj.month || "",
        stationTypes:this.formData.zhanDianType,
        tonnages:this.formData.dunwei,
        fuelTypes:this.formData.ranliaoType,
        //
        // time: this.formData.time,
        // isRecord: this.formData.devLog,
        // companyName: this.formData.companyName,
        // devUser: this.formData.cmpnanyDevUser,
        // reachStatus: this.formData.reachStatus,
        // cardType: this.formData.cardType,
        // vehicleCountMask: this.formData.vehicleCountMask,
        // mileageMask: this.formData.mileageMask,
        // percentage: this.formData.percentage,
      }

      // this.tableData = []
      http
          .oilStationBerthCountV2(params)
          .then((e) => {
            loading.close();
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }

            if (e.data.length == 0) {
              this.tableData = []
              return;
            }
            if (e.data.year&&e.data.month) {
              this.dimObj.year = e.data.year
              this.dimObj.month = e.data.month
              this.formData.time = e.data.year + "" + e.data.month
              // 更新dimension-popover的显示值
              if (this.$refs.objDimensionPopover) {
                this.$refs.objDimensionPopover.setCtrlValue()
              }
            }
            this.tableData = e.data.dataList.map((_) => {
              // _.decryptedCompanyName = false
              // _.companyCreditCodeIs = false
              // _.cmpnanyDevStartTime = _.devStartTime != '-' ? Util.format(new Date(_.devStartTime * 1).getTime(), "yyyy-MM-dd") : '-'
              // _.cmpnanyDevEndTime = _.devEndTime != '-' ? Util.format(new Date(_.devEndTime * 1).getTime(), "yyyy-MM-dd") : '-'
              // _.companyCardStatusText = this.getNmae(Util.companyCardStatusOption, _.companyCardStatus)
              // _.companyDevStatusText = this.getNmae(Util.devStatusOption, _.devStatus)
              // _.cardTypeText = this.getNmae(Util.cardTypeOption, _.cardType)
              // _.reachStatusText = this.getNmae(Util.reachStatusOptions, _.reachStatus)
              return _
            })
            this.total = e.data.total
            this.index = e.data.pageNum
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
            loading.close();
          })
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.getData()
          break
        default:
          break
      }
    },

    onWeekDialogCommand(params) {
      switch (params.type) {
        case 'ok':
          window.location.assign(http.getWeekCarOperateExport(params.data))
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.proTextSty{
  font-size: 14px;
}
.tableTitleSty{
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}
.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    //margin-bottom: 20px;
    margin-top: 20px;
  }
}

/deep/ .el-table__empty-block {
  width: 100% !important;
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

.pageBlock {
  display: flex;
  margin-top: 20px;
}
</style>
<style lang="stylus">
.el-cascader-menu {
  overflow: hidden;
}
</style>
